import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import RegisterIcon from "@mui/icons-material/AppRegistration";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import {Link, useNavigate} from "react-router-dom";
import PackagesImage from "./images/packages_vert.png"
import {Form, useForm} from "react-hook-form"
import React, {useState} from "react";
import axios from "axios";
import {Alert} from "@mui/material";
import Cookies from "js-cookie";

function encodeCredentials(username, password) {
    return btoa(`${username}:${password}`);
}
export default function Register() {
    const [alertSeverity, setAlertSeverity] = useState("info");
    const [alertMsg, setAlertMsg] = useState("Please enter your user info and select a subscription:");
    const {register, control} = useForm()

    const [emailAddress, setEmailAddress] = useState("");
    const [screenName, setScreenName] = useState("");
    const [password, setPassword] = useState("");
    const [rePassword, setRePassword] = useState("");
    const [subscription, setSubscription] = useState("aluminium");
    const navigate = useNavigate();
    function updateSub(sub) {
        setSubscription(sub);
    }

    const handleSubmit = async () => {

        if(password.includes(rePassword)) {
            const formData = new URLSearchParams();
            formData.append('email', emailAddress);
            formData.append('screen_name', screenName);
            formData.append('pass_hash', password);
            formData.append('subscription', subscription);
            try {
                const response = await axios.post('/api/user/createUser', formData, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                });
                setAlertMsg("User created, setting up payment...");
                setAlertSeverity("success");
                const expirationTime = new Date(new Date().getTime() + (60000 * 60 * 24));
                const passHash = response.data.passHash;
                Cookies.set('auth', passHash, { expires: expirationTime });
                Cookies.set('email', emailAddress, { expires: expirationTime });
                window.location.href = "/api/stripe/checkout?email=" + emailAddress + "&sub=" + subscription;
            } catch (error) {
                setAlertMsg("Email already registered.");
                setAlertSeverity("error");
            }
        } else {
            setAlertMsg("Passwords do not match.");
            setAlertSeverity("error");
        }
    };

    return (

        <div className="Section">
            <div className="SectionLtr">

              <span className='SectionBox'>
                  <span className="SectionHeadingIcon"><RegisterIcon sx={{ fontSize: 43 }}/></span>
                      <span className="SectionHeading">ANALYTICS</span>
                      <span className="SectionSubHeading">SUBSCRIBE</span>
                  <div className="_div_line_dual_grad"></div>
            <Form onSubmit={handleSubmit} control={control}>
                  <div className="_inputSection">

                      <div className="Alert">
                          <Alert severity={alertSeverity} className="Alert">{alertMsg}</Alert>
                      </div>
                      <div className="_inputLine">
                          <TextField type="email" id="email" {...register("email", {
                              required: true,
                              pattern: /^\S+@\S+$/i
                          })}
                                     label="Email Address" size="small"
                                     required
                                     onChange={e => setEmailAddress(e.target.value)}/>
                      </div>
                      <div className="_inputLine">
                          <TextField id="screen_name"  {...register("screen_name", {required: true})}
                                     label="Screen Name" size="small"
                                     required
                                     onChange={e => setScreenName(e.target.value)}/>
                      </div>


                      <div className="_inputLine">
                          <TextField id="pass_hash" {...register("pass_hash", {
                              required: true,
                              pattern: {
                                  value: /^[\u0000-\u00FF]+$/
                              }})}
                             label="Password" size="small"
                             type="password" required
                             onChange={e => setPassword(e.target.value)}/>
                      </div>
                      <div className="_inputLine">
                          <TextField id="re_password" {...register("re_password", {required: true})}
                                     label="Confirm Password" size="small"
                                     type="password" required
                                     onChange={e => setRePassword(e.target.value)}
                                     helperText="No special characters please."/>

                      </div>

                  </div>
                <div className="_div_line_dual_grad"></div>
                  <div className="_button_bar">
                      <div className="_button_bar_title">
                          Select a subscription:
                      </div>

                      <select id="subsciption" className="Select" {...register("subscription")}
                               onChange={e => setSubscription(e.target.value)}>
                          <option className="SelectItemTi" value="aluminium">ALUMINIUM - $9.99</option>
                          <option className="SelectItemTi" value="titanium">TITANIUM - $19.99</option>
                          <option className="SelectItemTi" value="inconel">INCONEL - $29.99</option>
                        </select>

                  </div>
                  <div className="_div_line_dual_grad"></div>
                  <div className="_button_bar">

                      <span className="_button_holder">
                          <Link to="/login"><BackButton/></Link>
                      </span>
                       <span className="_button_holder">
                          <RegisterButton/>
                      </span>

                    </div>

            </Form>
              </span>
                <span className="SectionBoxImagePort">
                    <img src={PackagesImage} alt="packages" className="SectionBoxImagePort"/>
                </span>
            </div>
        </div>
    );
}


function RegisterButton() {

    return (
        <Button type="submit" variant="contained" startIcon={< RegisterIcon/>}>
            Subscribe
        </Button>
    );
}

function BackButton() {
    return (
        <Button type="button" variant="outlined" startIcon={<ArrowBackOutlinedIcon/>} >
            Login
        </Button>
    );
}

